// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"styles-module__placeholder___IqJhD","addToCartBtn":"styles-module__addToCartBtn___h928m"};